import {Karen} from "../Karen";
import {KarenLayers, Layers} from "./KarenLayers";
import {Linear, Power4, TimelineLite, TweenLite} from "gsap";
import {KarenMultiplierFontText} from "./KarenMultiplierFontText";

export class KarenMultiplier extends PIXI.Container {
    private _multPrefix: string = "multFont";
    private _offsetRotation: number = 6.19592;
    private _reelId: number = 0;
    private _childContainer: PIXI.Container;
    private _multFont: KarenMultiplierFontText;

    constructor(reelId: number) {
        super();
        this._reelId = reelId;
        this.createMultiplierFont(this._multPrefix);
    }

    public updateMValue(multiplierVal: number, symbolName: string, noWin: boolean = false, overLap: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this.scale.set(1);
            }
        });
        KarenLayers.getLayer(Layers.SYMBOL_MULT)!.addChild(this);
        tl.to(this, {alpha: 1, duration: 0.03, ease: Linear.easeIn}, 0.01);
        if (symbolName !== "W" && !noWin) {
            tl.add(TweenLite.from(this.scale, 0.05, {
                x: 2,
                y: 2,
                ease: Power4.easeIn
            }), 0);
        }
        if (overLap) {
            this.updateChildMultiplier(multiplierVal);
        }
        return tl;
    }
    public updateMQuickerValue(multiplierVal: number, symbolName: string, noWin: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this.scale.set(1);
            }
        });
        KarenLayers.getLayer(Layers.SYMBOL_MULT)!.addChild(this);
        tl.to(this, {alpha: 1, duration: 0.01, ease: Linear.easeIn}, 0.01);
        if (symbolName !== "W" && !noWin) {
            tl.add(TweenLite.from(this.scale, 0.03, {
                x: 2,
                y: 2,
                ease: Power4.easeIn
            }), 0);
        }
        return tl;
    }

    public updateChildMultiplier(multiplierVal: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this.scale.set(1);
                this._childContainer.scale.set(1);
            }
        });
        this.createChildMultiplier(this._multPrefix);
        const multFontChild: KarenMultiplierFontText = this._childContainer.getChildByName(this._multPrefix + this._reelId) as KarenMultiplierFontText;
        this.updateSpriteTexture(multiplierVal, true, this._childContainer);
        this.addChild(this._childContainer);
        if (multFontChild) {
            multFontChild.text = "x" + multiplierVal;
            if (multiplierVal < 9) {
                multFontChild.x = 30;
            }
        }
        if (multiplierVal > 9) {
            this.x -= 7;
        }
        tl.to(this._childContainer, {alpha: 1, duration: 0.03, ease: Linear.easeIn}, 0);
        return tl;
    }

    public updateSpriteTexture(multiplierVal: number, isInfected: boolean = false, container: any = this): void {
        let sprite: PIXI.Sprite = container.getChildByName("background") as PIXI.Sprite;
        let multFont: KarenMultiplierFontText = container.getChildByName("multFont_" + this._reelId);
        if (multiplierVal > 9) {
            if (isInfected) {
                sprite.texture = Karen.assetLoader.getTextures("inf_background_double")[0];
                multFont.updateInfectiousStyle();
            } else {
                sprite.texture = Karen.assetLoader.getTextures("background_double")[0];
            }
        } else {
            if (isInfected) {
                sprite.texture = Karen.assetLoader.getTextures("inf_background_single")[0];
                multFont.updateInfectiousStyle();
            } else {
                sprite.texture = Karen.assetLoader.getTextures("background_single")[0];
            }

        }
        multFont.text = "x" + multiplierVal;
        if (multiplierVal > 9) {
            multFont.setPositionX(36);
        } else {
            multFont.setPositionX(28);
        }

    }

    public setMultiplierPosition(positionX: number, positionY: number): void {
        this.position.set(positionX, positionY);
    }

    private createMultiplierFont(multName: string): PIXI.Container {
        const backgroundSprite: PIXI.Sprite = new PIXI.Sprite(Karen.assetLoader.getTextures("background_double")[0]);
        backgroundSprite.name = "background";
        this.addChild(backgroundSprite);
        this._multFont = new KarenMultiplierFontText(multName, this._reelId);
        this.addChild(this._multFont);
        this.rotation = this._offsetRotation;
        this.name = "mult_" + this._reelId;
        this.alpha = 0;
        this.pivot.x = -28;
        this.pivot.y = 51;
        return this;
    }

    private createChildMultiplier(multName: string): PIXI.Container {
        this._childContainer = new PIXI.Container();
        const backgroundSprite: PIXI.Sprite = new PIXI.Sprite(Karen.assetLoader.getTextures("background_double")[0]);
        backgroundSprite.name = "background";
        const multFont: KarenMultiplierFontText = new KarenMultiplierFontText(multName, this._reelId);
        this._childContainer.addChild(backgroundSprite);
        this._childContainer.addChild(multFont);
        this._childContainer.name = "childContainer";
        this.rotation = this._offsetRotation;
        // Number will be from 0 to 3
        let randomNumber: Number = Math.floor(Math.random() * 4);
        let pivotY: number = 7;
        let pivotX: number = 0;
        switch (randomNumber) {
            case 0:
                pivotY = -7;
                pivotX = 0;
                break;
            case 1:
                pivotY = 7;
                pivotX = 0;
                break;
            case 2:
                pivotY = 0;
                pivotX = -7;
                break;
            case 3:
                pivotY = 0;
                pivotX = 7;
                break;
        }
        this._childContainer.pivot.x = -28;
        this._childContainer.x = -28 + pivotX;
        this._childContainer.pivot.y = 51;
        this._childContainer.y = this._childContainer.pivot.y + pivotY;
        return this._childContainer;
    }
}
